import React from "react";
import CommonFilterTable from "../../../component/table/TableFiltter";
import { lang, MODE_SCREEN } from "../../../constants/common.const";
import { Tooltip } from "antd";


const ListUnitMaster = ({
  currentNode,
  setCurrentNode,
  mode,
  dataSource,
  setFirstNodeFilter
}) => {

  const renderText = (text) => (
    <Tooltip title={text}>
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "inline-block", 
          maxWidth: "100%",
        }}
      >
        {text}
      </div>
    </Tooltip>
  );
  const columns = [
    { title: lang.UNIT_ID, dataIndex: "unitId", width: 100, align: "center" ,type:"number"},
    {
      title: lang.UNIT_NAME,
      dataIndex: "unitName",
      align: "left",
      width:200,
      render: renderText,

    },
    {
      title: lang.QUANTITY_CATEGORY,
      dataIndex: "typeName",
      align: "center",
      width:200,
      render: renderText,
      
    },
    {
      title: lang.DISPLAY_ORDER,
      dataIndex: "displayOrder",
      align: "center",
      type:"number",
      width:200,
      render: renderText,
    },
  ];

  return (
    <div>
        <CommonFilterTable
            setFirstNodeFilter={setFirstNodeFilter}
            rowClassName={(record) =>
              currentNode && record.id == currentNode.id
                ? "selected-row-facilityMaster"
                : ""
            }
            onRow={(record) => ({ onClick: () => setCurrentNode(record) })}
            rowKey="id"
            data={dataSource.data}
            columns={columns}
            className="table-selected-custom table-equipment-custome my-custom-table mt10"
            scrollY={"calc(100vh - 280px)"}
            paging={true}
            tableKey="unit"
            addedLeft={160}
            disabledFilter={mode !== MODE_SCREEN.VIEW}
            idFocus={dataSource.idFocus}
          />
    </div>
  );
};

export default ListUnitMaster;
